import React, { createContext, useContext, useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  Paper,
  IconButton,
  Container,
} from "@mui/material";
import { Outlet } from "react-router-dom";
import { ReactComponent as UserStoryIcon } from "../../../images/userStoryIcon.svg";
import { ReactComponent as RunTestIcon } from "../../../images/RunTestIcon.svg";
import { ReactComponent as APIResetFormIcon } from "../../../images/APIResetFormIcon.svg";
import { ReactComponent as GenerateButtonIcon } from "../../../images/generateButton.svg";
import { Link } from "@mui/material";
import { ReactComponent as DeleteIcon } from "../../../images/APIDeleteIcon.svg";
import { ReactComponent as ErrorIcon } from "../../../images/APIErrorIcon.svg";
import { ReactComponent as SuccessIcon } from "../../../images/APISuccessIcon.svg";
import yaml from "js-yaml";
import { LoadingModalContext } from "../../main-pages/ServicePage";
import { useNavigate, useLocation } from "react-router-dom";
import { generateTestCasesForAPI, swaggerToPostman, APITraceabilityMatrix } from "../../../services/webServices";
import { APITestCaseFlowDataContext } from "../../main-pages/output-pages/ApiTestingOutputPage";
import MessagePopup from "../../popup-components/MessagePopup";
import { handleProgressBar } from "../../custom-components/ProgressBar/ProgressBarWithAPI.js";

const ImportAPIDefinition = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [getUrl, setGetUrl] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [fileContent, setFileContent] = useState(null);
  const [fileContentItems, setFileContentItems] = useState([]);
  const [fileContentFinalArray, setfileContentFinalArray] = useState([]);
  const [status, setStatus] = useState(null);
  const [finalArray, setFinalArray] = useState([]);
  const { setLoadingState } = useContext(LoadingModalContext);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [traceabilityMatrixData, setTraceabilityMatrixData] = useState({});

  const handleGetUrlChange = (e) => {
    setGetUrl(e.target.value);
  };

  useEffect(() => {
    if (location.state && location.state.clearFileData) {
      setUploadedFile(null);
      setFileContent(null);
      setFileContentItems([]);
    }
  }, [location.state]);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];

    if (!file) {
      setPopupMessage("No file selected or unsupported file type.");
      setPopupOpen(true);
      return;
    }

    const fileName = file.name;
    const validExtensions = [".json", ".yaml", ".yml", ".postman_collection"];
    const fileExtension = fileName
      .slice(fileName.lastIndexOf("."))
      .toLowerCase();

    if (!validExtensions.includes(fileExtension)) {
      setPopupMessage("Please upload a valid file (.json, .yaml, .yml).");
      setPopupOpen(true);
      return;
    }

    setUploadedFile(file);
    const reader = new FileReader();

    reader.onload = (event) => {
      try {
        const content = event.target.result;
        let parsedYAML;
        if (fileExtension === ".json" || fileExtension === ".postman_collection") {
          parsedYAML = JSON.parse(content);
        } else {
          parsedYAML = yaml.load(event.target.result);
        }
        if (parsedYAML.item === undefined && fileExtension === ".json") {
          // alert(
          //   "Upload a valid input file.")
          setPopupMessage("Upload a valid input file.");
          setPopupOpen(true);
          setUploadedFile(null)

        }
        if (parsedYAML && parsedYAML.item && parsedYAML.item.length > 0) {
          setFileContentItems(parsedYAML.item);


        }
        if (parsedYAML && Object.keys(parsedYAML).length > 0) {
          setFileContent(parsedYAML);





        } else {
          setFileContent(null);
        }
      } catch (error) {
        console.error("Error parsing YAML:", error);
        setFileContent(null);
        setPopupMessage(
          "Error parsing file. Please upload a valid YAML or JSON."
        );
        setPopupOpen(true);
      }
    };

    reader.readAsText(file);
  };

  const handleFileRemove = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setUploadedFile(null);
    setFileContent(null);
    setFileContentItems([]);
  };
  const handleRunTest = () => {
    setStatus("error");
  };

  const handleResetForm = () => {
    setUploadedFile(null); // Clear file
    setGetUrl(""); // Clear URL
    setStatus(null); // Clear status
    setFileContent(null); // Add this line - Clear file content
    setFileContentItems([]); // Add this line - Clear file content items
    setfileContentFinalArray([]); // Add this line - Clear final array
    setFinalArray([]); // Add this line - Clear final array
  };

  function flattenPostmanItems(items) {
    const flat = [];

    function recurse(subItems) {
      subItems.forEach(item => {
        if (item.request) {
          flat.push(item); // it's a request
        } else if (item.item && item.item.length > 0) {
          recurse(item.item); // it's a folder
        }
      });
    }
    recurse(items);
    return flat;
  }




  // const generateTestCases = async () => {
  //   setLoading(true);
  //   const finalArray = [];

  //   try {
  //     if (fileContentItems && fileContentItems.length > 0) {
  //       for (let item = 0; item < fileContentItems.length; item++) {
  //         try {
  //           const responseData = await generateTestCasesForAPI(
  //             fileContentItems[item]
  //           );
  //           console.log(responseData.data, "responseData");
  //           finalArray.push(...responseData.data.testcases);
  //         } catch (error) {
  //           console.log(
  //             error?.response?.data?.error || error.message,
  //             "errorrrrrr"
  //           );
  //         }
  //       }

  //     } else {
  //       try{

  //       const responseData = await swaggerToPostman(fileContent);
  //       console.log(responseData.data, "responseData");
  //       if (responseData.data) {
  //         for (let i = 0; i < responseData.data.length; i++) {
  //           try {

  //           const testcasesresponse = await generateTestCasesForAPI(
  //             responseData.data[i]
  //           );
  //           console.log(testcasesresponse.data, "testcasesresponse");
  //           finalArray.push(...testcasesresponse.data.testcases); 




  //    }catch (error) {
  //     console.log(
  //       error?.response?.data?.error || error.message,
  //       "errorrrrrr"
  //     );
  //    }
  //   }  catch (error) {
  //     console.error("Error generating test cases:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

const generateTestCases = async () => {
  const totalFolders = fileContentItems.length;
 
  let progressHandler;
  progressHandler = handleProgressBar({setLoadingState, totalDurationMs:216000});
  progressHandler.start("Generating Test Cases for each end-point");


  let tcCounter = 1; // global test case ID counter
  const finalArray = [];
  let traceabilityMatrix = null;

    try {

      if (fileContentItems && fileContentItems.length > 0) {
        try {
          //Mew code using promise for parallel calls
          const promise = fileContentItems.map((item) => { return generateTestCasesForAPI(item) })
          const results = await Promise.allSettled(promise);
          const allTestCases = [];
          results.map((result) => {
            if (result.status === "fulfilled" && result.value?.data?.testcases) {
              allTestCases.push(...result.value.data.testcases);
            } else {
              console.error("One call failed:", result.reason);
            }
          })

       
          if (allTestCases && allTestCases.length > 0) {
            const updatedTestCases = allTestCases.map(testcase => {
              // const isFunctional = testcase.Category?.toLowerCase().includes("functional");
              const isFunctional = testcase.Category?.toLowerCase() === "functional testing";

              const subCategory = testcase["Sub-Category"]?.toLowerCase() || "";

              let prefix = isFunctional ? "TCD_FT" : "TCD_NFT";
              let shortCode = "";

              if (subCategory.includes("positive")) shortCode = "POS";
              else if (subCategory.includes("negative")) shortCode = "NEG";
              else if (subCategory.includes("boundary")) shortCode = "BOUND";
              else if (subCategory.includes("error")) shortCode = "ERR";
              else if (subCategory.includes("security")) shortCode = "SEC";
              else if (subCategory.includes("performance")) shortCode = "PERF";

              const padded = String(tcCounter).padStart(2, "0");
              const id = `${prefix}_${padded}_${shortCode}`;
              tcCounter++; // increment global counter

              return {
                ...testcase,
                "Test Case ID": id
              };
            });

            finalArray.push(...updatedTestCases);
          }
        } catch (error) {
          console.log(
            error?.response?.data?.error || error.message,
            "Error processing item:"
          );
          // setPopupMessage("Error processing some test cases. Please check the file format and try again.");
          // setPopupOpen(true);
        }
        const filteredTestCases = finalArray.map(testcase => ({
          "Test Case ID": testcase["Test Case ID"],
          "API Endpoint": testcase["API Endpoint"],
          "Method": testcase["Method"],
          "Test Description": testcase["Test Description"],
          "Category": testcase["Category"]

        }))

      try {
       progressHandler.updateMessage("Genertaing Traceability Matrix");
        const response = await APITraceabilityMatrix(filteredTestCases);


          if (response.data !== null) {
            traceabilityMatrix = response.data;
            setTraceabilityMatrixData(response.data)

          }
        } catch (error) {
          console.error(
            error?.response?.data?.error || error.message,
            "Error processing item:"

          );
          setPopupMessage("Error generating traceability matrix. Please try again.");
          setPopupOpen(true);
        }
      } else {
        // yml flow
        try {
          progressHandler = handleProgressBar({ setLoadingState, totalDurationMs: 195000 })
         
            progressHandler.start("Generating Test Cases for API Endpoints");
         
          const responseData = await swaggerToPostman(fileContent);


          if (responseData.data.item) {
            const flattenedItems = flattenPostmanItems(responseData.data.item);

            const promises = flattenedItems.map(async (item, i) => {
              

              try {
                const testcasesresponse = await generateTestCasesForAPI(item);



                // finalArray.push(...testcasesresponse.data.testcases);
                if (testcasesresponse.data && testcasesresponse.data?.testcases) {

                  return testcasesresponse.data.testcases;
                }




              } catch (error) {
                console.log(
                  error?.response?.data?.error || error.message,
                  "Error processing swagger item:", i
                );
                // setPopupMessage("Error processing some test cases. Please check the file format and try again.");
                // setPopupOpen(true);
              }
              return [];
            }
            );
            const results = await Promise.allSettled(promises);
            for (const result of results) {
              if (result.status === "fulfilled" && Array.isArray(result.value)) {
                const updatedTestCases = result.value.map(testcase => {
                  // const isFunctional = testcase.Category?.toLowerCase().includes("functional");
                  const isFunctional = testcase.Category?.toLowerCase() === "functional testing";
                  const subCategory = testcase["Sub-Category"]?.toLowerCase() || "";
                  let prefix = isFunctional ? "TCD_FT" : "TCD_NFT";
                  let shortCode = "";
                  if (subCategory.includes("positive")) shortCode = "POS";
                  else if (subCategory.includes("negative")) shortCode = "NEG";
                  else if (subCategory.includes("boundary")) shortCode = "BOUND";
                  else if (subCategory.includes("error")) shortCode = "ERR";
                  else if (subCategory.includes("security")) shortCode = "SEC";

                  const padded = String(tcCounter).padStart(2, "0");
                  const id = `${prefix}_${padded}_${shortCode}`;
                  tcCounter++;
                  return {
                    ...testcase,
                    "Test Case ID": id
                  };
                });
                finalArray.push(...updatedTestCases);
              }
            }





            const filteredTestCases = finalArray.map(testcase => ({
              "Test Case ID": testcase["Test Case ID"],
              "API Endpoint": testcase["API Endpoint"],
              "Method": testcase["Method"],
              "Test Description": testcase["Test Description"],
              "Category": testcase["Category"]

            }))

            try {
              progressHandler.updateMessage("Generating Traceability Matrix");
              const response = await APITraceabilityMatrix(filteredTestCases);



              if (response.data !== null) {
                traceabilityMatrix = response.data;
                setTraceabilityMatrixData(response.data)
              }
            } catch (error) {
              console.error(
                error?.response?.data?.error || error.message,
                "Error processing item"

              );
              setPopupMessage("Error generating traceability matrix. Please try again.");
              setPopupOpen(true);
            }
          }
        } catch (error) {
          console.error(
            error?.response?.data?.error || error.message,
            "Error converting swagger to postman"
          );
          setPopupMessage("Error converting swagger to postman. Please try again.");
          setPopupOpen(true);
        }
      }

 await progressHandler.finishAndClose();
if (finalArray.length > 0) {
  navigate("/dashboard/api-testing/manual", {
    state: {
      ...location.state,
      generateTestCasesData: finalArray,
      button: "importAPIDefinition",
      traceabilityMatrix: traceabilityMatrix

          },
        });
      } else {
        console.warn("No test cases were generated");
      }
    } catch (error) {
      console.error("Error generating test cases:", error);
      setLoadingState({ open: false, message: "", progress: null });
      setPopupMessage("Something went wrong while generating test cases.");
      setPopupOpen(true);
    } finally {
      if (progressHandler) {
        progressHandler.stop();
      }
      setLoadingState({ open: false, message: "", progress: null });
    }
  };

  
  const defaultExpand = finalArray.length === 0;
  return (
    <Box sx={{ width: "100%", height: "100%", overflowY: "auto" }}>
      <Box sx={{ px: 4, py: 1, overflowX: "auto", ml: "-20px" }}>
         <Typography variant="subtitle1" sx={{color:"#808080", mb:2
        }}>Upload API specifications directly from your device</Typography>


        {/* File Upload Section */}
        {!uploadedFile ? (
          <label htmlFor="file-upload">
            <input
              id="file-upload"
              type="file"
              accept=".json,.yml,.yaml" // Adjust allowed file types
              style={{ display: "none" }} // Hide the default file input
              onChange={handleFileUpload}
            />
            <Paper
              variant="outlined"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: 3,
                border: "2px dashed #B3D6FF",
                borderRadius: 2,
                bgcolor: "#49A3FF0F",
                mb: 3,
                cursor: "pointer",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <UserStoryIcon sx={{ fontSize: 30, color: "#757575" }} />
                <Box>
                  <Typography variant="body1" sx={{ mt: 1 }}>
                    Import Document
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Swagger YAML File, Postman Collection JSON File, ...
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </label>
        ) : (
          <Paper
            variant="outlined"
            sx={{
              display: "flex",
              alignItems: "center",
              p: 3,
              border: "2px dashed #B3D6FF",
              borderRadius: 2,
              bgcolor: "#49A3FF0F",
              mb: 3,
              cursor: "pointer",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                width: "100%",
              }}
            >
              <UserStoryIcon sx={{ fontSize: 30, color: "#757575" }} />
              <Typography noWrap sx={{ flexGrow: 1, maxWidth: "200px" }}>
                {uploadedFile.name}
              </Typography>
              <Box sx={{ display: "flex", ml: "auto" }}>
                <Box sx={{ mr: 2 }}>
                  <label htmlFor="file-upload">
                    <input
                      id="file-upload"
                      type="file"
                      accept=".json,.yml,.yaml,.postman_collection" // Adjust allowed file types
                      style={{ display: "none" }}
                      onChange={handleFileUpload}
                    />
                    <Link
                      component="button"
                      variant="body2"
                      sx={{ color: "#0094FB", textDecoration: "none" }}
                      onClick={() =>
                        document.getElementById("file-upload").click()
                      }
                    >
                      Change
                    </Link>
                  </label>
                </Box>
                <IconButton onClick={handleFileRemove} size="small">
                  <DeleteIcon color="error" />
                </IconButton>
              </Box>
            </Box>
          </Paper>
        )}

        {/* Test Connection Section */}
        {/* <Box sx={{ p: 2, borderRadius: 2, mb: 3, bgcolor: "#FAFAFA" }}>
        <Typography variant="subtitle1" >
          Test Connection
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Enter Authorization URL"
          label="Base URL (Optional override)"
          value={getUrl}
          onChange={handleGetUrlChange}
          sx={{ mt: 2.5, mb: 3 }}
          helperText="If your imported definition contains a server URL, you can leave this blank."
        />
        {status === null ? (
          <Button
            variant="outlined"
            sx={{ textTransform: "none", mr: 3, minWidth: "50px" }}
            onClick={handleRunTest}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <RunTestIcon width={15} height={15} />
              <Typography>Run Test Connection</Typography>
            </Box>
          </Button>
        ) : (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "1px solid",
              borderColor: status === "success" ? "#45A133" : "#FF5522",
              borderRadius: 2,
              p: 1.5,
              bgcolor: "white",


              // bgcolor: status === "success" ? "#E8F5E9" : "#FFEBEE", // Light green/red background
              mt: 2
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {status === "success" ? (
                <CheckCircleIcon color="success" />
              ) : (
                <ErrorOutlineIcon color="error" />
              )}
              <Typography variant="body1">
                {status === "success" ? "Connected Successfully" : "Something went wrong"}
              </Typography>
            </Box>
            <Typography variant="body1" color="#49A3FF">Retry Connection</Typography>
          </Box>
      
      {status === "error" && (
          <Typography
            variant="body1"
            color="#49A3FF"
            sx={{ cursor: "pointer" }}
            onClick={() => setStatus(null)} // Reset state on retry
          >
            Retry Connection
          </Typography>
        )}


    )}


      </Box> */}
        {/* Test Connection Section */}
        {/* <Box sx={{ p: 2, borderRadius: 2, mb: 3, bgcolor: "#FAFAFA" }}>
        <Typography variant="subtitle1">Test Connection</Typography>

        <TextField
          fullWidth
          variant="outlined"
          placeholder="Enter Authorization URL"
          label="Base URL (Optional override)"
          value={getUrl}
          disabled
          onChange={handleGetUrlChange}
          sx={{ mt: 2.5, mb: 3 }}
          helperText="If your imported definition contains a server URL, you can leave this blank."
        />

        {status === null ? (
          <Button
            variant="outlined"
            sx={{ textTransform: "none", mr: 3, minWidth: "50px" }}
            onClick={handleRunTest}
            disabled
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <RunTestIcon width={15} height={15} />
              <Typography sx={{ color: "#49A3FF" }}>
                Run Test Connection
              </Typography>
            </Box>
          </Button>
        ) : (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "1px solid",
              borderColor: status === "success" ? "#45A133" : "#FF5522",
              borderRadius: 2,
              p: 1.5,
              bgcolor: "white",
              mt: 1,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {status === "success" ? (
                <SuccessIcon color="success" />
              ) : (
                <ErrorIcon color="error" />
              )}
              <Typography variant="body1">
                {status === "success"
                  ? "Connected Successfully"
                  : "Something went wrong"}
              </Typography>
            </Box>

            {status === "error" && (
              <Typography
                variant="body1"
                color="#49A3FF"
                sx={{ cursor: "pointer" }}
                onClick={() => setStatus(null)} // Reset state on retry
              >
                Retry Connection
              </Typography>
            )}
          </Box>
        )}
      </Box> */}

        {/* Buttons Section */}
        <Box
          sx={{ display: "flex", justifyContent: "flex-end", mt: 2, mb: 0 }}
          borderTop={"1px solid #C6C6C6"}
          padding={2}
        >
          {/* <Button
            startIcon={<APIResetFormIcon />}
            sx={{ color: "#49A3FF", textTransform: "none" }}
            onClick={handleResetForm}
          >
            Reset Form
          </Button> */}

          <Button
            variant="contained"
            // startIcon={<GenerateButtonIcon />}
            disabled={!fileContent}
            sx={{
              textTransform: "none",
              backgroundColor: "#49A3FF",
              color: "white",
              float: "right"
            }}
            onClick={generateTestCases}
            defaultExpanded={defaultExpand}
          >
            Generate Test Cases
          </Button>
        </Box>
      </Box>
      <MessagePopup
        modalOpen={popupOpen}
        message={popupMessage}
        okayHandler={() => setPopupOpen(false)}
      />
    </Box>
  );
};

export default ImportAPIDefinition;
